export default __webpack_public_path__ + "assets/overview-manager-ipad.png";